import { axiosInstance } from "./axios-instance"
import * as endpoints from "../constants/api-constants"

class RedeemService {

  static postRedeemPrizes(payload, config) {
    payload.country = parseInt(process.env.COUNTRY_CODE)
    return axiosInstance.post(endpoints.redeemPrizes, payload, config).then(resp => resp.data)
  }

  static postPointsRedeem(payload, config) {
    return axiosInstance
      .post(endpoints.consultingRedeem, payload, config)
      .then(resp => resp.data)
  }

  static getRedeem(payload, config) {
    return axiosInstance
      .get(`${endpoints.getRedeem}/${payload.idProduct}`, config)
      .then(resp => resp.data)
  }
}

export default RedeemService
